export const CHILDREN = {
  nickname: 'PRODUCTS.CHILDREN.shortname',
  isHidden: true,
  icon:'children'
};
